<template>
  <v-container>
    <v-row class="balance-overview__row">
      <v-col cols="2"> </v-col>

      <v-col cols="1" class="balance-overview__headline">N (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">N (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">N (kg/ha)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (kg/ha)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (kg/ha)</v-col> 
      <v-col cols="1"></v-col>
    </v-row>

    <v-row  class="balance-overview__row">
      <v-col cols="2" class="balance-overview__row-text">
        {{ $t('balanceOverview.sumDemand')  }}
      </v-col>

      <v-col cols="1"> </v-col>
      <v-col cols="1"
        ><formatted-value
          :value="balance['N'].nutrient_demand"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['N'].nutrient_demand_per_ha"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"></v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].nutrient_demand"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].nutrient_demand_per_ha"
          chip
          showZero

          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"></v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].nutrient_demand"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].nutrient_demand_per_ha"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"> </v-col>
    </v-row>

    <hr class="balance__row-divider" />
    

    <v-row class="balance-overview__row">
      <v-col cols="2" class="balance-overview__row-text">
        {{ $t('balanceOverview.sumNutrients') }}
      </v-col>

      <v-col cols="1"></v-col>
      <v-col cols="1"
        ><formatted-value
          :value="balance['N'].demand_fulfillment_overview"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['N'].demand_fulfillment_per_ha_overview"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"></v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].demand_fulfillment_overview"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].demand_fulfillment_per_ha_overview"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"></v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].demand_fulfillment_overview"
          chip
          showZero
          :threshold="1"
          :scale="0.001"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].demand_fulfillment_per_ha_overview"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>
 
      <v-col cols="1"> </v-col>
    </v-row>


    <hr class="balance__row-divider" />
    <v-row class="balance-overview__row"> 
      <v-col cols="2" class="balance-overview__row-text">
         <span v-text="valueText"/>
      </v-col>

      <v-col cols="1">
        <formatted-value
          :value="surplusValuePct"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
          showZero
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="surplusValue"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="surplusValueKgHa"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
        />
      </v-col>

      <v-col cols="1">
        <formatted-value
          :value="balance['P'].surplus_pct"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
          showZero
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].surplus"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].surplus_per_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
        />
      </v-col>

      <v-col cols="1">
        <formatted-value
          :value="balance['K'].surplus_pct"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
          showZero
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].surplus"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].surplus_per_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
        />
      </v-col>

      <v-col cols="1"> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import FormattedValue from "./FormattedValue.vue";

export default {
  props: {
    isBalance : { 
      type: Boolean,
      required: true
    },
  },

  components: {
    FormattedValue,
  },

  computed: {
    ...mapGetters(["balance"]),

    valueText() {
      if (this.isBalance) {
        return this.$i18n.t('balanceOverview.demandCoverage1');
      }
      else {
        return this.$i18n.t('balanceOverview.demandCoverage2');
      }
    },

    surplusValuePct() {
      if (this.isBalance) {
        return this.balance['N'].surplus_pct;
      }
      else {
        return this.balance['N'].surplus_pct_standard;
      }
    },

    surplusValue() {
      if (this.isBalance) {
        return this.balance['N'].surplus;
      }
      else {
        return this.balance['N'].surplus_standard;
      }
    },

    surplusValueKgHa() {
      if (this.isBalance) {
        return this.balance['N'].surplus_per_ha;
      }
      else {
        return this.balance['N'].surplus_standard_per_ha;
      }
    },
    
  },

  methods: {
    chipColorForPercentage (value, tolerance=10) {
      if (!value) {
        return '';
      }
      return Math.abs(100 - value) <= tolerance ? 'green' : 'red'
    }
  }
  
};
</script>
